import i18next from 'i18next';
import es from './locales/es.json';
import en from './locales/en.json';

i18next.init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
